"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakpoint = void 0;
const compareBreakpoints_1 = require("./compareBreakpoints");
const getBreakpoint = (width, breakpointsMap = compareBreakpoints_1.defaultBreakpointsMap) => {
    let nextBreakpoint = undefined;
    const breakpoints = Object.keys(breakpointsMap);
    for (let i = 0; i < breakpoints.length; i++) {
        const breakpoint = breakpoints[i];
        const breakpointWidth = breakpointsMap[breakpoint];
        if (breakpointWidth <= width &&
            (!nextBreakpoint || breakpointsMap[nextBreakpoint] < breakpointWidth)) {
            nextBreakpoint = breakpoint;
        }
    }
    return nextBreakpoint;
};
exports.getBreakpoint = getBreakpoint;
